import { PlannerValidation } from './PlannerValidation';
/**
 * Don't allow organizers, that fits on both shelves ans drawers, to be be placed drawers.
 * Enabled temporarily when clicking these organizers from shelves part of menu so they only are placed in shelves or frames then.
 */
export class DrawerOrganizerValidation extends PlannerValidation {
    constructor(coreApi, organizerProductType, drawerFrameProductType) {
        super(coreApi, 'DrawerOrganizerValidation');
        this.organizerProductType = organizerProductType;
        this.drawerFrameProductType = drawerFrameProductType;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const guest = snapActionCandidate.guestRoot;
        const host = snapActionCandidate.host;
        if (this.coreApi.entities.isProductType(guest, this.organizerProductType) &&
            this.coreApi.entities.isProductType(host, this.drawerFrameProductType)) {
            return this.validationFail('Can´t add organizer to drawer');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=DrawerOrganizerValidation.js.map